import { CartItem, Order } from "@/types/ApiTypes";
import { AppConfig } from "@/utils/AppConfig";
import { formatMoney } from "@/utils/helpers";
import { useTranslation } from "react-i18next";
import { GiPresent } from "react-icons/gi";
import { IoMdClose } from "react-icons/io";


export default function ReviewBodyModal({ toggleModal, order }: { toggleModal: () => void, order: Order }) {
    const { t, i18n } = useTranslation();
    return (
        <>
            <div onClick={toggleModal} className="fixed inset-0 bg-black bg-opacity-50 z-[9999] p-5 flex items-center justify-center">
                <div onClick={e => e.stopPropagation()} className="z-[9999]  gap-2 flex-col flex md:w-1/2 lg:w-[600px] w-full overflow-auto max-h-[90vh] bg-white text-black rounded-lg p-5">
                    <div onClick={toggleModal} className=" text-xl self-end text-red-600 ">
                        <IoMdClose className="cursor-pointer" />
                    </div>
                    <div className="flex border px-2 py-5  justify-between">
                        <h2>{t("ordersBody.phone")}</h2>
                        {order?.customer.phone !== null && order?.customer.phone ? order?.customer?.phone : t("ordersBody.Deleted")}
                    </div>
                    {order?.deliveryType === "delivery" && (<div className="flex border px-2 py-5 justify-between">
                        <div>{t("orders.driverName")}</div>
                        <div>{order?.driver?.username}</div>
                    </div>)}

                    <div className="flex border px-2 py-5 items-center justify-center">
                        <div className="flex items-center justify-center flex-col">
                            <span className="h-full font-semibold"> {order.deliveryType === "receiving" ? t("ordersBody.Receiving") : order.deliveryType === "dine-in" ? t("ordersBody.DineIn") : order.deliveryType === "delivery" && t("ordersBody.delivery")}</span>

                            {order.deliveryType === "dine-in" && <span> {t("ordersBody.Floor")}{order.dineIn?.floor.number} - {t("ordersBody.Table")} {order.dineIn?.table.number}</span>}
                            {order.deliveryType === "delivery" && order.address && (
                                <div className="text-sm leading-relaxed mt-3 flex flex-col items-center text-end whitespace-pre-line text-gray-800">

                                    <div>
                                        {t("address.city")} - {order.address.city}
                                    </div>
                                    <div>
                                        {t("address.street")} - {order.address.street}
                                    </div>
                                    <div>
                                        {t("address.building")} - {order.address.buildingNumber}
                                    </div>
                                    <div>
                                        {t("address.floor")} - {order.address.floorNumber}
                                    </div>
                                    <div>
                                        {t("address.apartment")} - {order.address.apartmentNumber}
                                    </div>
                                    {order.address?.additionalInfo && (
                                        <div className="mt-3 text-xs  text-gray-500 text-center">
                                            <h1 className="font-bold mb-2">  {t("address.info")}</h1>
                                            {order.address.additionalInfo}
                                        </div>
                                    )}
                                </div>
                            )}



                        </div>
                    </div>
                    <div className="flex border px-2 py-5 justify-between">
                        <h2>{t("ordersBody.Branch")}</h2>
                        <span>  {t(order?.branch.nameEN, order?.branch.nameAR)}</span>
                    </div>
                    <div className="flex flex-col border px-2 py-5 gap-3">
                        <h2 className="font-bold">{t("ordersBody.OrderDetails")}</h2>
                        <div className={`flex flex-col text-[13px] gap-1 `}>
                            {order?.items.map((item: CartItem, index) => {
                                return (

                                    <div key={index} className={`flex flex-col gap-1  py-1 ${order.items.length - 1 !== index && "border-b"}`}  >
                                        <span className="font-bold" dir="ltr">{t(item.nameEN, item.nameAR)} X {item.quantity} </span>
                                        {item.notes && <div className="flex flex-col">
                                            <span className="text-[14px] font-semibold">{t("ordersBody.ItemNote")}</span>
                                            <span className="whitespace-pre-wrap break-words ">
                                                {item.notes && item.notes}
                                            </span>
                                        </div>}
                                        {item.addons.length > 0 && <span className="flex flex-col ">{t("ordersBody.Addons")}   <span className="font-normal flex flex-col">{item.addons?.map((addon, i) => <span key={i}>{t(addon.nameEN, addon.nameAR)}</span>)}</span></span>}
                                        {item.options.length > 0 && <span className="flex flex-col "> {t("ordersBody.Options")}<span className="flex flex-col font-normal" >{item.options.map((option) => option.options.map((item, i) => <span key={i}>{t(item.nameEN, item.nameAR)}</span>))}</span></span>}
                                    </div>

                                )
                            })}
                        </div>
                        <div>
                            {order.notes && <div className="flex flex-col">
                                <span className="text-[14px] font-semibold">{t("ordersBody.OrderNote")}</span>
                                <span className="whitespace-pre-wrap break-words">
                                    {order.notes && order.notes}
                                </span>
                            </div>}
                        </div>
                    </div>
                    <div className="flex border gap-3 flex-col py-3 px-2">
                        {order?.usedWalletBalance > 0 && <>
                            <div className="flex justify-between">
                                <h1>{t("ordersBody.UsedWalletBalance")}</h1>
                                <span dir="rtl" className="flex items-center gap-1 text-green-600">{formatMoney(order?.usedWalletBalance)} {AppConfig.currency.icon()}</span>
                            </div>
                        </>}
                        {order?.couponDiscount > 0 && <>
                            <div className="flex justify-between">
                                <h1>{t("ordersBody.UsedCouponDiscount")}</h1>
                                <span dir="rtl" className="flex items-center gap-1 text-green-600">{formatMoney(order?.couponDiscount)} {AppConfig.currency.icon()}</span>
                            </div>
                        </>}
                        {order.pointsDiscount && order.pointsDiscount > 0 && <>
                            <div className="flex justify-between gap-1 md:hidden text-[12px]">
                                <h1 className="flex items-center gap-1">{t("ordersBody.points")} </h1>
                                <span dir="rtl" className="flex items-center gap-1 text-green-600"> ({order?.usedPoints} <GiPresent size={17} className="mb-1" />  = {order?.pointsDiscount} {AppConfig.currency.icon()})  </span>
                            </div>
                        </>}
                        <div className="flex justify-between">
                            <h2>{t("ordersBody.Total")}</h2>
                            <div className="flex gap-2">
                                <span dir="rtl">{i18n.language && order?.total}
                                    {AppConfig.currency.icon()}</span>
                                <span className={`${order?.paid === true ? "text-green-600" : "text-red-600"}`}>{order?.paid === true ? t("ordersBody.Paid") : t("ordersBody.Unpaid")}</span>
                            </div>
                        </div>
                    </div>
                    {order.review?.comment || order.review?.driverComment ? (<div className="flex border gap-3 flex-col py-3 px-2">
                        {order.review?.comment && (<div className="flex flex-col gap-1">
                            <span className="font-semibold">{t("review.orderComment")}</span>
                            {order.review?.comment && <span className=" text-gray-500 break-all whitespace-pre-wrap">{order.review.comment}</span>}
                        </div>)}

                        {order.review?.driverComment && (<div className="flex flex-col gap-1">
                            <span className="font-semibold">{t("review.driverComment")}</span>
                            {order.review?.driverComment && <span className=" text-gray-500 break-all whitespace-pre-wrap">{order.review?.driverComment}</span>}
                        </div>)}

                    </div>) : ""}

                    <button onClick={toggleModal} className="bg-red-500 px-4 py-2 text-white w-fit rounded-lg self-end mt-2">{t("close")}</button>
                </div>
            </div>

        </>
    )
}
